import React, { useState, useEffect } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import AdminPanel from './AdminPanel';
import { Link } from 'react-router-dom';

const { FiArrowLeft, FiLogIn } = FiIcons;

const AdminPage = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [authError, setAuthError] = useState(null);
  const [initialSettings, setInitialSettings] = useState(null);

  // Simple local authentication (for demo purposes)
  const ADMIN_CREDENTIALS = {
    email: 'admin@example.com',
    password: 'admin123'
  };

  useEffect(() => {
    const checkAuth = () => {
      const savedAuth = localStorage.getItem('admin_auth');
      if (savedAuth) {
        const auth = JSON.parse(savedAuth);
        if (auth.isAuthenticated) {
          setUser({ email: auth.email });
        }
      }
      setLoading(false);
    };

    checkAuth();
  }, []);

  useEffect(() => {
    if (user) {
      const fetchSettings = () => {
        const savedSettings = localStorage.getItem('landing_settings');
        if (savedSettings) {
          setInitialSettings(JSON.parse(savedSettings));
        }
      };
      fetchSettings();
    }
  }, [user]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setAuthError(null);
    setIsLoggingIn(true);

    // Simulate authentication delay
    setTimeout(() => {
      if (email === ADMIN_CREDENTIALS.email && password === ADMIN_CREDENTIALS.password) {
        const authData = {
          isAuthenticated: true,
          email: email,
          timestamp: Date.now()
        };
        localStorage.setItem('admin_auth', JSON.stringify(authData));
        setUser({ email });
      } else {
        setAuthError('Invalid email or password');
      }
      setIsLoggingIn(false);
    }, 1000);
  };

  const handleLogout = () => {
    localStorage.removeItem('admin_auth');
    setUser(null);
    setEmail('');
    setPassword('');
    setAuthError(null);
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-fuchsia-500"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100">
      <div className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <Link to="/" className="flex items-center text-gray-600 hover:text-gray-900">
                <SafeIcon icon={FiArrowLeft} className="mr-2" />
                Back to Site
              </Link>
            </div>
            {user && (
              <button 
                onClick={handleLogout} 
                className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors" 
              >
                Logout
              </button>
            )}
          </div>
        </div>
      </div>
      {user ? (
        initialSettings ? (
          <AdminPanel 
            onSave={(settings) => setInitialSettings(settings)} 
            initialSettings={initialSettings} 
          />
        ) : (
          <div className="text-center py-10">Loading settings...</div>
        )
      ) : (
        <div className="fixed inset-0 bg-gray-100 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-md p-6">
            <h3 className="text-2xl font-bold mb-6 text-gray-800 text-center">Admin Login</h3>
            <form onSubmit={handleLogin}>
              <div className="space-y-4">
                <input 
                  type="email" 
                  placeholder="Email" 
                  value={email} 
                  onChange={(e) => setEmail(e.target.value)} 
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-fuchsia-500" 
                  required 
                />
                <input 
                  type="password" 
                  placeholder="Password" 
                  value={password} 
                  onChange={(e) => setPassword(e.target.value)} 
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-fuchsia-500" 
                  required 
                />
              </div>
              {authError && <p className="text-red-500 text-sm mt-4">{authError}</p>}
              <div className="mt-6">
                <button 
                  type="submit" 
                  disabled={isLoggingIn} 
                  className="w-full bg-fuchsia-500 text-white py-3 rounded-lg hover:bg-fuchsia-600 transition-colors font-semibold flex items-center justify-center disabled:opacity-50" 
                >
                  {isLoggingIn ? (
                    <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                  ) : (
                    <>
                      <SafeIcon icon={FiLogIn} className="mr-2" />
                      Login
                    </>
                  )}
                </button>
              </div>
              <div className="mt-4 p-3 bg-gray-100 rounded-lg">
                <p className="text-xs text-gray-600 text-center">
                  Demo credentials:<br />
                  Email: admin@example.com<br />
                  Password: admin123
                </p>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminPage;